import {HubConnectionBuilder} from '@aspnet/signalr'

const connection = new HubConnectionBuilder().withUrl('/hubs/processManager').build()

export default {
  start() {
    return connection.start()
  },
  stop() {
    return connection.stop()
  },
  on(method, handler) {
    return connection.on(method, handler)
  },
  off(method, handler) {
    return connection.off(method, handler)
  },
}
